<!--账号配置Ec-->
<template>
  <div class="account-setting">
    <div class="step">
      <h6>第一步：配置账号</h6>
      <el-form label-width="200px" label-position="left" :model="formAccount" ref="formAccount" @keyup.enter.native="submitForm('formAccount')">
        <el-form-item label="销帮帮账号CorpID" prop="param1" :rules="{ required: true, message: '请输入销帮帮账号CorpID', trigger: 'change' }">
          <el-input placeholder="在销帮帮系统/系统设置/公司信息查看" v-model="formAccount.param1"></el-input>
        </el-form-item>
        <el-form-item label="销帮帮账号Token" prop="param2" :rules="{ required: true, message: '请输入销帮帮账号Token', trigger: 'change' }">
          <el-input placeholder="在销帮帮系统/系统设置/公司信息查看" v-model="formAccount.param2"></el-input>
        </el-form-item>
        <el-form-item label="销帮帮版本" prop="param3" :rules="{ required: true, message: '销帮帮版本', trigger: 'change' }">
          <el-radio v-model="formAccount.param3" label="1">saas</el-radio>
          <el-radio v-model="formAccount.param3" label="2">pro</el-radio>
        </el-form-item>
      </el-form>
    </div>
    <div class="step">
      <h6>第二步：信息配置</h6>
      <p class="goSetting">来源配置、字段配置</p>
    </div>
    <div class="step">
      <h6>第三步：配置话务排班</h6>
      <p class="goSetting"><span>*</span>去资源同步crm-销帮帮-话务排班-日期配置</p>
    </div>
    <div class="step">
      <h6>第四步：打开同步开关</h6>
      <el-form label-width="200px" label-position="left" :model="formAccount" ref="formAccount" @keyup.enter.native="submitForm('formAccount')">
        <el-form-item label="同步数据到销帮帮" prop="sync">
          <el-switch v-model="formAccount.sync"></el-switch>
        </el-form-item>
        <!-- <p class="tip"><i class="el-icon-warning-outline"></i>资源同步crm只支持招商智投(智投)模式</p> -->
        <div class="button">
          <el-button type="primary" size="small" @click="submitForm('formAccount')">保存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
  import {FormArgument} from '@/models/ec-setting'
  import Api from '@/api/client/ec-setting'
  export default {
    data () {
      return {
        crmCode: 'xbb',
        formAccount: new FormArgument()
      }
    },
    created () {
      this.getAccount()
      this.formAccount.param3 = '1'
    },
    methods: {
      getAccount () {
        const crmCode = {
          crmCode: this.crmCode
        }
        Api.getEcAccount(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.formAccount = body
          } else {
            this.table.list = []
            this.$message.error(body.error)
          }
        })
      },
      submitForm (formName) {
        this.$confirm('确定保存？若销帮帮账号CorpID变化了，之前的配置数据将被清除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.formAccount.crmCode = this.crmCode
          this.$refs[formName].validate((valid) => {
            if (valid) {
              Api.addEcAccount(this.formAccount, response => {
                let status = response.status || 0
                let body = response.data || []
                if (status === 200 || status === 204) {
                  this.$message.success('保存成功！')
                } else {
                  this.$message.error(body.error)
                }
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }
    }
  }
</script>
<style scoped lang="scss">
.account-setting{
  margin-top:15px;
  h6{
    color:#1F2F3D;
    font-size: 22px;
    font-weight: normal;
    line-height: 3;
    margin:0;
  }
  .goSetting{
    color:#606266;
    font-size: 14px;
    margin:0 0 20px;
    span{
      color:#FF0000;
      padding-right:5px;
    }
  }
  .tip{
    color:#FF4F4F;
    font-size: 12px;
    position: relative;
    top:-10px;
    i{
      margin-right:5px;
      font-size: 14px;
    }
  }
  .el-input{
    width:50%;
  }
  .button{
    text-align: center;
    button{
      width:100px;
      height:30px;
      line-height:1;
      background:rgba(8,94,204,1);
      border-radius:4px;
      padding:0;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/xbb/XbbcrmAccount.vue